<template>
    <div class="row justify-content-center">
        <div class="col-md-8">
            <div style="padding: 20px 5px 60px 5px;">
                <div class="accordion" id="accordionExample">
                    <div class="accordion-item">
                        <h2 class="accordion-header" id="headingOne">
                            <button class="accordion-button" type="button" data-bs-toggle="collapse"
                                    data-bs-target="#collapseOne" aria-expanded="true" aria-controls="collapseOne">
                                С чего начать
                            </button>
                        </h2>
                        <div id="collapseOne" class="accordion-collapse collapse show" aria-labelledby="headingOne"
                             data-bs-parent="#accordionExample">
                            <div class="accordion-body">
                                Выберите понравившееся вам изображение. Для этого загрузите изображение для генерации и
                                посмотрите результаты.
                            </div>
                        </div>
                    </div>
                    <div class="accordion-item">
                        <h2 class="accordion-header" id="headingTwo">
                            <button @click="counter += 1" class="accordion-button collapsed" type="button"
                                    data-bs-toggle="collapse"
                                    data-bs-target="#collapseTwo" aria-expanded="false" aria-controls="collapseTwo">
                                Какое изображение лучше сделать
                            </button>
                        </h2>
                        <div id="collapseTwo" class="accordion-collapse collapse" aria-labelledby="headingTwo"
                             data-bs-parent="#accordionExample">
                            <div class="accordion-body">
                                Выбирайте фотографии с крупными элементами и контрастным задним фоном. Попробуйте
                                несколько своих портретов или изображений лиц ваших друзей. На картинах также отлично
                                получаются животные. Чтобы картина получилась более реалистичной используйте крупные
                                детали, лица. Выбрав портрет вы можете попробовать генерацию несколько раз изменяя
                                масштаб и выбирая нужный участок на нем.
                            </div>
                        </div>
                    </div>
                    <div class="accordion-item">
                        <h2 class="accordion-header" id="heading4">
                            <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                                    data-bs-target="#collapse4" aria-expanded="false" aria-controls="collapse4">
                                Сколько времени у меня уйдет для создания картины
                            </button>
                        </h2>
                        <div id="collapse4" class="accordion-collapse collapse" aria-labelledby="heading4"
                             data-bs-parent="#accordionExample">
                            <div class="accordion-body">
                                Обычно это занимает 10-12 часов времени, поэтому не торопитесь завершить вашу картину за
                                день.
                            </div>
                        </div>
                    </div>

                    <div class="accordion-item">
                        <h2 class="accordion-header" id="heading5">
                            <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                                    data-bs-target="#collapse5" aria-expanded="false" aria-controls="collapse5">
                                Как получить инструкцию
                            </button>
                        </h2>
                        <div id="collapse5" class="accordion-collapse collapse" aria-labelledby="heading5"
                             data-bs-parent="#accordionExample">
                            <div class="accordion-body">
                                Перейдите в раздел <b>Ввести код</b> и укажите ваш код. Qr-код для получения вашего кода
                                находится на внутренней части холста под картонной вкладкой с красками. После введения
                                кода вам будет доступно скачивание инструкции для выбранной вами картины. Генерировать
                                картины можно многократно, а вот создать инструкцию вы сможете только для одного
                                понравившегося вам изображения.
                            </div>
                        </div>
                    </div>
                    <div class="accordion-item">
                        <h2 class="accordion-header" id="heading6">
                            <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                                    data-bs-target="#collapse6" aria-expanded="false" aria-controls="collapse6">
                                Что такое инструкция
                            </button>
                        </h2>
                        <div id="collapse6" class="accordion-collapse collapse" aria-labelledby="heading6"
                             data-bs-parent="#accordionExample">
                            <div class="accordion-body">
                                Инструкция – это схема для рисования вашей картины. На ней отображаются квадратные
                                пиксели с рисунком, который обозначает конкретный цвет краски. Пиксели объединены в
                                блоки размерами 7х7 пикселей для удобства рисования.
                            </div>
                        </div>
                    </div>
                    <div class="accordion-item">
                        <h2 class="accordion-header" id="heading7">
                            <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                                    data-bs-target="#collapse7" aria-expanded="false" aria-controls="collapse7">
                                С чего лучше начать рисовать
                            </button>
                        </h2>
                        <div id="collapse7" class="accordion-collapse collapse" aria-labelledby="heading7"
                             data-bs-parent="#accordionExample">
                            <div class="accordion-body">
                                Блоки размерами 7*7 пикселей объеденены в панели, каждая из которых находится на своем
                                листе pdf инструкции. Рекомендуем закрашивать панели поочередно, так вам будет проще
                                ориентироваться. Начинать закрашивание лучше со светлых оттенков, так у вас будет
                                возможность исправить цвет пикселя, если вы ошибетесь.
                            </div>
                        </div>
                    </div>
                    <div class="accordion-item">
                        <h2 class="accordion-header" id="heading8">
                            <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                                    data-bs-target="#collapse8" aria-expanded="false" aria-controls="collapse8">
                                После закрашивания первого ряда ничего не понятно
                            </button>
                        </h2>
                        <div id="collapse8" class="accordion-collapse collapse" aria-labelledby="heading8"
                             data-bs-parent="#accordionExample">
                            <div class="accordion-body">
                                Не торопитесь с выводами - это пиксельная картина, поэтому финальный результат вы
                                сможете оценить только когда закрасите всю картину и удивитесь тому, как она
                                преобразилась.
                            </div>
                        </div>
                    </div>
                    <div class="accordion-item">
                        <h2 class="accordion-header" id="heading9">
                            <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                                    data-bs-target="#collapse9" aria-expanded="false" aria-controls="collapse9">
                                Как мне поменять инструкцию
                            </button>
                        </h2>
                        <div id="collapse9" class="accordion-collapse collapse" aria-labelledby="heading9"
                             data-bs-parent="#accordionExample">
                            <div class="accordion-body">
                                Если вы уже приступили к созданию картины, нет никакого смысла менять инструкцию, т.к.
                                перекрыть цветом большой блок готовой картины - плохая идея. Если вы изменили свое
                                решение до начала рисования, напишите нам в поддержку с указанием вашего кода и
                                описанием вашей проблемы. Помните что ваша предыдущая инструкция безвозвратно удалится.
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "FaqN"
    }
</script>

<style scoped>

</style>